
import { mapGetters } from "vuex";

export default {
  layout: "default",

  data() {
    return {
      adminEmail: "support@emiratescort.com",

      copied: false,

      sendForm: false,

      counterVal: 100,

      subjects: ["Proposition", "Question", "Сomplaint"],

      form: {
        name: "",
        email: "",
        subject: null,
        text: "",
      },

      valid: false,

      showPass: false,

      textRules: [
        (v) => !!v || this.$t("validations.message-is-required"),
        (v) =>
          (v && v.length <= this.counterVal) ||
          this.$t("validations.use-a-maximum-characters", [this.counterVal]),
      ],

      nameRules: [
        (v) => !!v || this.$t("validations.name-is-required"),
        (v) =>
          (v && v.length >= 3) ||
          this.$t("validations.use-a-minimum-characters", [3]),
      ],

      subjectRules: [(v) => !!v || this.$t("validations.subject-is-required")],

      passRules: [
        (v) => !!v || this.$t("validations.pass-is-required"),
        (v) =>
          (v && v.length >= 8) ||
          this.$t("validations.use-a-minimum-characters", [8]),
      ],

      emailRules: [
        (v) => !!v || this.$t("validations.email-is-required"),
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("validations.e-mail-must-be-valid"),
      ],
    };
  },

  async fetch({ store }) {
    await store.dispatch("retrieveContacts");
  },

  head() {
    return {
      title: this.seoTexts?.title || this.$t("contact-us"),

      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/contact-us`,
        },
      ],

      meta: [
        {
          hid: "description",
          name: "description",
          content: this.seoTexts?.description || "",
        },
      ],

      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.jsonld),
        },
      ],

      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    ...mapGetters({
      contacts: "getContacts",
      seoTexts: "global/getSeoTexts",
    }),

    h1() {
      return this.seoTexts?.title || this.$t("contact-us");
    },

    jsonld() {
      return {
        "@context": "http://schema.org",
        "@type": "ContactPage",
        mainEntity: {
          "@type": "WebPage",
          "@id": `${this.$config.baseUrlApp}${this.$route.path}`,
          name: "Contact Us - Emiratescort",
          description:
            "Contact Emiratescort for any inquiries regarding our services. Our team is available to assist you with any questions or concerns you may have.",
        },
      };
    },
  },

  methods: {
    async copyText() {
      try {
        await this.$copyText(this.adminEmail);
        this.copied = true;
      } catch (e) {
        console.error(e);
      }
    },

    async submitForm() {
      if (this.$refs.form.validate()) {
        try {
          const responce = await this.$axios.post("/api/contacts", this.form);

          this.$refs.form.reset();
          this.sendForm = true;

          console.log(responce);
        } catch (error) {
          console.log(error);
          this.$refs.form.reset();
        }
      }
    },
  },
};
